var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.556 3.4a2.456 2.456 0 0 1 2.45 2.294l.005.162v.655H19a.9.9 0 0 1 .113 1.793L19 8.311h-.656V18.3a2.456 2.456 0 0 1-2.294 2.45l-.161.006H8.11a2.456 2.456 0 0 1-2.45-2.295l-.005-.161-.001-9.989H5a.9.9 0 0 1-.113-1.793L5 6.511h2.988v-.655a2.456 2.456 0 0 1 2.295-2.45l.161-.006h3.112zm2.988 4.911H7.455V18.3c0 .33.243.602.56.648l.096.008h7.778c.329 0 .602-.243.648-.56l.007-.096V8.311zm-6.1 2.089a.9.9 0 0 1 .893.787l.007.113v4.667a.9.9 0 0 1-1.793.113l-.007-.113V11.3a.9.9 0 0 1 .9-.9zm3.112 0a.9.9 0 0 1 .893.787l.007.113v4.667a.9.9 0 0 1-1.793.113l-.007-.113V11.3a.9.9 0 0 1 .9-.9zm0-5.2h-3.112a.656.656 0 0 0-.648.559l-.007.097-.001.655h4.423v-.655a.656.656 0 0 0-.559-.649l-.096-.007z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.8bb8b235faa35b2fcfffb71f4d79fea8.svg";
export { ForwardRef as ReactComponent };